<template>
  <div class="gx-sb custom-el-wrapper">
    <div class="gx-sb__head">
<!--      <h1 class="gx-main__title" style="margin-bottom: 0;">店铺看板</h1>-->
        <button class="btn" @click="openShopGroupManageDialog">分组管理</button>
        <button class="btn btn--primary" :disabled="selectedRows.length === 0" @click="openShopBatchGroupDialog()">批量设置分组</button>
    </div>
    <!--平台-->
    <div class="gx-sb__plat-tabs">
      <button
          v-for="p in platformOptions"
          :key="p.value"
          class="gx-sb__plat-tab"
          :class="{ 'gx-sb__plat-tab--on': searchData.platform === p.value }"
          @click="switchPlatform(p.value)"
      >{{ p.label }}</button>
    </div>
    <!-- 筛选栏 -->
    <div class="gx-sb__filter custom-form-wrap">
      <el-form inline size="mini">

        <el-form-item label="店铺名称">
          <el-select v-model="searchData.shop_id" placeholder="全部" clearable filterable @change="reloadFirstPage">
            <el-option v-for="item in shopOptions" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺分组">
          <el-select v-model="searchData.group_id" placeholder="全部分组" clearable filterable @change="reloadFirstPage">
            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="体验分">
          <el-select v-model="searchData.score_range" placeholder="全部" clearable class="w140">
            <el-option v-for="item in scoreRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="否违规">
          <el-select v-model="searchData.has_violation" placeholder="全部" clearable class="w140">
            <el-option v-for="item in violationOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否授权">
          <el-select v-model="searchData.has_auth" placeholder="全部" clearable class="w140">
            <el-option v-for="item in authOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form inline size="mini">
        <el-form-item label="" style="margin-right: auto">
          <div class="gx-sb__time">
            <button
                v-for="t in timeOptions"
                :key="t.id"
                type="button"
                class="gx-sb__time-btn"
                :class="{ 'gx-sb__time-btn--on': timeSelectId === t.id }"
                @click="selectTime(t)"
            >{{ t.name }}</button>
            <el-date-picker
                v-model="displayDateRange"
                type="daterange"
                range-separator="-"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="datePickerOptions"
                @change="customDateChange"
                style="width:240px;">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>

          <el-button type="primary" @click="reloadFirstPage">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--商品状态汇总-->
    <div class="gx-sb__summary" v-if="false">
      <div class="gx-sb__summary-head">
        <div class="gx-sb__summary-title">商品状态汇总 </div>
        <div class="gx-sb__summary-dec">爆款 · 动销款 · 无数据款 · 任务执行情况</div>
        <div class="gx-sb__summary-btns">
          <button class="gx-sb__btn gx-sb__btn--mi gx-sb__btn--blue" @click="jumpPage('ops-goods')">→ 商品看板</button>
          <button class="gx-sb__btn gx-sb__btn--mi gx-sb__btn--yellow" @click="jumpPage('ops-task')">→ 任务大厅</button>
        </div>
      </div>
      <div class="gx-sb__summary-body">
        <div class="gx-sb__summary-cards">
          <div
            v-for="item in productStatusCards"
            :key="item.key"
            class="gx-sb__summary-card"
            :style="{ background: item.bg, borderColor: item.border }"
          >
            <div class="gx-sb__summary-card-top">
              <span class="gx-sb__summary-ico">{{ item.icon }}</span>
              <span class="gx-sb__summary-card-label" :style="{ color: item.color }">{{ item.label }}</span>
            </div>
            <div class="gx-sb__summary-card-num" :style="{ color: item.color }">{{ item.count }}</div>
            <div class="gx-sb__summary-card-sub">{{ item.desc }}</div>
          </div>
        </div>
        <div class="gx-sb__summary-bars">
          <div class="gx-sb__summary-bar-col">
            <div class="gx-sb__summary-bar-title">商品健康度分布</div>
            <div v-for="row in healthDistribution" :key="row.key" class="gx-sb__summary-bar-item" >
              <div class="gx-sb__summary-bar-row" :style="{color:row.color}">
                <span class="gx-sb__summary-bar-label">{{ row.label }}</span>
                <span class="gx-sb__summary-bar-val">{{ row.count }}件 ({{ row.percent }}%)</span>
              </div>
              <div class="gx-sb__summary-bar-track">
                <span class="gx-sb__summary-bar-fill" :style="{ width: row.percent + '%', background: row.color }"></span>
              </div>
            </div>
          </div>
          <div class="gx-sb__summary-bar-col">
            <div class="gx-sb__summary-bar-title">任务执行情况</div>
            <div
              v-for="row in taskDistribution"
              :key="row.key"
              class="gx-sb__summary-bar-item"
            >
              <div class="gx-sb__summary-bar-row" :style="{color:row.color}">
                <span class="gx-sb__summary-bar-label">{{ row.label }}</span>
                <span class="gx-sb__summary-bar-val">{{ row.count }}件 ({{ row.percent }}%)</span>
              </div>
              <div class="gx-sb__summary-bar-track">
                <span class="gx-sb__summary-bar-fill" :style="{ width: row.percent + '%', background: row.color }"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gx-sb__meta">
      <div class="gx-sb__sel-tag">
        <span class="gx-sb__sel-tag-dot"></span>
        <span>已选 {{selectedRows.length}} 个店铺</span>
      </div>
      <span v-if="dataTime" class="gx-sb__meta-time">数据时间：{{ dataTime }}</span>
      <button type="button" class="gx-sb__btn gx-sb__btn--sm gx-sb__btn--yellow" style="margin-left: auto"  @click="openFieldConfig">指标配置</button>
    </div>

    <!--统计-->
    <div class="gx-sb__stats" v-if="false">
      <div class="gx-sb__stats-tabs">
        <button
          v-for="t in statTabs"
          :key="t.key"
          class="gx-sb__stats-tab"
          :class="{ 'gx-sb__stats-tab--on': activeStatTab === t.key }"
          @click="activeStatTab = t.key"
        >{{ t.label }}</button>
      </div>
      <div class="gx-sb__stats-row">
        <div
          v-for="(card, idx) in currentStatCards"
          :key="idx"
          class="gx-sb__stats-cell"
        >
          <div class="gx-sb__stats-label">{{ card.label }}</div>
          <div class="gx-sb__stats-num">{{ card.value }}</div>
          <div class="gx-sb__stats-sub">{{ card.sub }} 昨日</div>
        </div>
      </div>
    </div>

    <!-- 数据表格 + 分页 -->
    <div class="gx-sb__table-page-wrapper">
      <div class="gx-sb__table">
        <table>
        <thead>
          <tr>
            <th>
              <label class="gx-sb__checkall">
                <input type="checkbox" :checked="isAllSelected" @change="toggleSelectAll" />
                <span class="gx-sb__checkall-box">
                    <svg v-if="isAllSelected" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </span>
              </label>
            </th>
            <th class="gx-sb__th-fixed gx-sb__th-shop">店铺名称 <span class="gx-sb__sort">↕</span></th>
            <th class="gx-sb__th-fixed gx-sb__th-auth">授权状态</th>
            <template v-for="group in activeGroups">
              <th
                v-for="col in group.fields"
                :key="col.key"
                class="gx-sb__th-col"
              >
                <span :title="col.tip ? col.label : undefined">{{ col.short }} <span class="gx-sb__sort">↕</span></span>
              </th>
            </template>
            <th class="gx-sb__th-fixed gx-sb__th-ops">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in tableData" :key="row.mer_shop_id || row.shop_id">
            <td>
              <label class="gx-sb__check">
                <input type="checkbox" :checked="isRowSelected(row)" @change="toggleRowSelect(row)"  />
                <span class="gx-sb__check-box">
                    <svg v-if="isRowSelected(row)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </span>
              </label>
            </td>
            <td class="gx-sb__td-fixed gx-sb__td-shop">
              <div class="gx-sb__shop-cell">
                <span class="gx-sb__shop-avatar">{{ shopInitial(row.shop_name) }}</span>
                <div class="gx-sb__shop-name">{{ row.shop_name }}</div>
              </div>
            </td>
            <td class="gx-sb__td-fixed gx-sb__td-auth">
              <span class="gx-sb__auth" :class="row.score_update_time_status == 1 ? 'gx-sb__auth--ok' : 'gx-sb__auth--err'">
                <span class="gx-sb__auth-dot"></span>
                {{ row.score_update_time_status == 1 ? '已授权' : '未授权' }}
              </span>
            </td>
            <template v-for="group in activeGroups">
              <td
                v-for="col in group.fields"
                :key="col.key"
                class="gx-sb__td-col"
              >
                <span :class="cellClass(col, row[col.key])">{{ formatCell(col, row[col.key]) }}</span>
              </td>
            </template>
            <td class="gx-sb__td-fixed gx-sb__td-ops">
              <div class="gx-sb__ops">
                <button
                  type="button"
                  class="gx-sb__op gx-sb__op--view"
                  @click="goDetail(row)"
                >查看更多</button>
                <button class="gx-sb__op gx-sb__op--warn" @click="showViolations(row)">查看违规</button>
              </div>
            </td>
          </tr>
          <tr v-if="!tableData.length">
            <td :colspan="4 + totalFieldCount" class="gx-sb__empty">暂无数据</td>
          </tr>
        </tbody>
        </table>
      </div>
      <div class="gx-sb__page">
        <Pagination
          :total="pageData.total"
          :page.sync="pageData.page"
          :limit.sync="pageData.limit"
          :page-sizes="[20, 50, 100, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          @pagination="handlePagination"
        />
      </div>
    </div>

    <!-- 指标配置弹窗 -->
    <div v-if="showFieldConfig" class="gx-modal gx-sb__field-config-modal" @click.self="closeFieldConfig">
      <div class="gx-modal-box gx-sb__field-config-box">
        <div class="gx-modal-head gx-modal-head--gray">
          <span class="gx-modal-title">指标配置</span>
          <button class="gx-modal-close" @click="closeFieldConfig">✕</button>
        </div>
        <div class="gx-modal-body">
          <div v-for="group in fieldGroups" :key="group.name" class="gx-sb__cfg-group">
            <div class="gx-sb__cfg-group-title">
              <span class="gx-sb__cfg-bar" :style="{ background: groupBar(group.type) }"></span>
              {{ group.name }}
              <span class="gx-sb__cfg-count">{{ selectedFieldCount(group) }}/{{ group.fields.length }}</span>
              <button class="gx-sb__cfg-checkall" @click="toggleGroup(group)">{{ isGroupAll(group) ? '取消全选' : '全选' }}</button>
            </div>
            <div class="gx-sb__cfg-items">
              <label
                v-for="f in group.fields"
                :key="f.key"
                class="gx-sb__cfg-item"
                :class="{ 'gx-sb__cfg-item--on': tempSelectedFields.includes(f.key) }"
              >
                <input type="checkbox" :value="f.key" v-model="tempSelectedFields" />
                <span>{{ f.label }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="gx-modal-foot gx-modal-foot--gray">
          <button class="gx-modal-foot-btn" @click="closeFieldConfig">取消</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" @click="confirmFieldConfig">保存配置</button>
        </div>
      </div>
    </div>

    <!-- 违规记录弹窗 -->
    <div v-if="showViolationDialog" class="gx-modal" @click.self="showViolationDialog = false">
      <div class="gx-modal-box gx-sb__modal-box--lg">
        <div class="gx-modal-head gx-modal-head--gray">
          <span class="gx-modal-title">{{ violationDialogTitle }} — 违规信息</span>
          <button class="gx-modal-close" @click="showViolationDialog = false">✕</button>
        </div>
        <div class="gx-modal-body" style="padding: 0">
          <div class="gx-sb__violation-table">
            <table>
              <thead>
                <tr>
                  <th v-for="h in ['违规时间', '违规类型', '违规标题', '违规产品', '冻结金额', '扣款金额']" :key="h">{{ h }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, i) in violationList" :key="i">
                  <td>{{ formatTimestamp(v.violation_time) }}</td>
                  <td>
                    <span :class="{'gx-sb__violation-tag':v.violation_type}">{{ v.violation_type ||'——' }}</span>
                  </td>
                  <td>
                    <div class="gx-sb__violation-title" style="color:#1a1a2e;">{{ v.violation_title }}</div>
                  </td>
                  <td>
                    <div class="gx-sb__violation-title">{{ v.violation_product }}</div>
                  </td>
                  <td>
                    <span :class="Number(v.frozen_amount)>0?'gx-sb__red':'gx-sb__gray'">¥{{ v.frozen_amount }}</span>
                  </td>
                  <td>
                    <span :class="Number(v.deduction_amount)>0?'gx-sb__red':'gx-sb__gray'">¥{{v.deduction_amount}}</span></td>
                </tr>
                <tr v-if="!violationList.length">
                  <td :colspan="5" class="gx-sb__empty">暂无违规记录</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="gx-sb__violation-foot">
          <div class="gx-sb__violation-total">共 {{violationList.length}} 条</div>
          <button class="gx-sb__violation-btn" @click="showViolationDialog = false">关闭</button>
        </div>
      </div>
    </div>

    <!-- 分组管理弹窗 -->
    <div v-if="groupManageVisible" class="gx-modal" @click.self="groupManageVisible = false">
      <div class="gx-modal-box gx-sb__modal-box--md">
        <div class="gx-modal-head gx-modal-head--gray">
          <span class="gx-modal-title">店铺分组管理</span>
          <button class="gx-modal-close" @click="groupManageVisible = false">✕</button>
        </div>
        <div class="gx-modal-body">
          <div class="gx-sb__gm-toolbar">
            <button class="gx-sb__btn" @click="handleAddShopGroup">新增分组</button>
          </div>
          <div class="gx-sb__gm-table">
            <table>
              <thead>
                <tr>
                  <th>分组名称</th>
                  <th style="width:90px">店铺数</th>
                  <th style="width:90px">排序</th>
                  <th style="width:150px">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in groupList" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td class="gx-sb__mono">
                    <div class="gx-sb__td-red">{{ item.shop_count ?? '-' }}</div>
                  </td>
                  <td>
                    <div class="gx-sb__gm-sort">
                      <button @click="moveShopGroup(item, index,'asc')">↑</button>
                      <button @click="moveShopGroup(item, index,'desc')">↓</button>
                    </div>
                  </td>
                  <td>
                    <button class="gx-sb__td-btn gx-sb__td-btn-edit" @click="handleEditShopGroup(item)">编辑</button>
                    <button class="gx-sb__td-btn gx-sb__td-btn-del" @click="handleDeleteShopGroup(item)">删除</button>
                  </td>
                </tr>
                <tr v-if="groupList.length === 0">
                  <td colspan="4" class="gx-sb__empty">暂无分组</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="gx-modal-foot no-top-bor">
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" @click="groupManageVisible = false">完成</button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑分组 -->
    <div v-if="groupFormVisible" class="gx-modal" @click.self="groupFormVisible = false">
      <div class="gx-modal-box gx-sb__modal-box--sm">
        <div class="gx-modal-head gx-modal-head--gray">
          <span class="gx-modal-title">{{ groupForm.id ? '编辑分组' : '新增分组' }}</span>
          <button class="gx-modal-close" @click="groupFormVisible = false">✕</button>
        </div>
        <div class="gx-modal-body">
          <div class="gx-sb__modal-label">分组名称</div>
          <el-input v-model="groupForm.name" size="small" maxlength="50" show-word-limit placeholder="请输入分组名称" ></el-input>
          <div class="gx-sb__modal-label" style="margin-top: 16px">排序值</div>
          <div class="gx-sb__gm-sort-input">
            <button @click="groupForm.sort = Math.max(0, groupForm.sort - 1)">−</button>
            <input v-model.number="groupForm.sort" type="number" min="0" />
            <button @click="groupForm.sort += 1">+</button>
          </div>
        </div>
        <div class="gx-modal-foot">
            <button class="gx-modal-foot-btn" @click="groupFormVisible = false">取消</button>
            <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="groupFormLoading" @click="submitShopGroupForm">
              {{ groupFormLoading ? '保存中...' : '确定' }}
            </button>
        </div>
      </div>
    </div>

    <!-- 批量设置分组弹窗 -->
    <div v-if="batchGroupVisible" class="gx-modal" @click.self="batchGroupVisible = false">
      <div class="gx-modal-box gx-sb__modal-box--sm">
        <div class="gx-modal-head gx-modal-head--gray ">
          <span class="gx-modal-title">设置店铺分组</span>
          <button class="gx-modal-close" @click="batchGroupVisible = false">✕</button>
        </div>
        <div class="gx-modal-body custom-form-wrap">
          <el-form size="small">
            <div class="gx-sb__sel-tag">
              <span class="gx-sb__sel-tag-dot"></span>
              <span>已选 {{batchGroupRows.length}} 个店铺</span>
            </div>
            <el-form-item label="选择分组">
              <el-select v-model="batchGroupId" placeholder="请选择分组" clearable style="width: 90%">
                <el-option label="移出分组" :value="0"></el-option>
                <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="gx-modal-foot">
          <button class="gx-modal-foot-btn" @click="batchGroupVisible = false">取消</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="batchGroupLoading" @click="submitShopBatchSetGroup">
            {{ batchGroupLoading ? '保存中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getShopViolations } from '../../api/main/shop_board'
import Pagination from '@/components/newUi/Pagination.vue'

const douyinFieldGroups = [
  {
    name: '体验分（实时）',
    type: 'experience',
    fields: [
      { key: 'experience_score', label: '体验分', short: '体验分', fmt: 'score', shortWidth: 80 },
      { key: 'product_experience_score', label: '商品体验得分', short: '商品体验', fmt: 'score', shortWidth: 90 },
      { key: 'logistics_experience_score', label: '物流体验得分', short: '物流体验', fmt: 'score', shortWidth: 90 },
      { key: 'service_experience_score', label: '服务体验得分', short: '服务体验', fmt: 'score', shortWidth: 90 },
      { key: 'negative_behavior_deduction', label: '差行为扣分', short: '差行扣分', fmt: 'score', shortWidth: 85 }
    ]
  },
  {
    name: '交易指标（当天）',
    type: 'trade',
    fields: [
      { key: 'income_amt', label: '成交金额', short: '成交金额', fmt: 'money', shortWidth: 100 },
      { key: 'pay_amt', label: '用户支付金额', short: '支付金额', fmt: 'money', shortWidth: 100 },
      { key: 'refunded_pay_amt_pay_time', label: '退款后用户支付金额(支付时间)', short: '退后支付额', tip: true, fmt: 'money', shortWidth: 100 },
      { key: 'pay_qc_plat_coupon_amt', label: '智能优惠券金额', short: '优惠券额', tip: true, fmt: 'money', shortWidth: 90 },
      { key: 'refund_pay_qc_plat_coupon_amt_pay_time', label: '退款后智能优惠券金额(支付时间)', short: '退后券额', tip: true, fmt: 'money', shortWidth: 90 },
      { key: 'pay_plat_cost_amt', label: '电商平台补贴金额', short: '平台补贴', fmt: 'money', shortWidth: 90 },
      { key: 'refund_pay_plat_cost_amt_pay_time', label: '退款后电商平台补贴金额(支付时间)', short: '退后补贴', tip: true, fmt: 'money', shortWidth: 90 },
      { key: 'author_subsidy_amt', label: '达人补贴金额', short: '达人补贴', fmt: 'money', shortWidth: 90 },
      { key: 'deposit_pay_amt', label: '预售定金', short: '预售定金', fmt: 'money', shortWidth: 90 },
      { key: 'pay_cnt', label: '成交订单数', short: '订单数', fmt: 'num', shortWidth: 80 },
      { key: 'pay_combo_cnt', label: '成交件数', short: '成交件数', fmt: 'num', shortWidth: 85 },
      { key: 'per_pay_combo_price', label: '件单价', short: '件单价', fmt: 'money', shortWidth: 80 },
      { key: 'pay_ucnt', label: '成交人数', short: '成交人数', fmt: 'num', shortWidth: 85 },
      { key: 'per_usr_pay_amt', label: '客单价', short: '客单价', fmt: 'money', shortWidth: 80 },
      { key: 'net_income_amt', label: '净成交金额', short: '净成交额', fmt: 'money', shortWidth: 95 },
      { key: 'net_pay_cnt', label: '净成交订单量', short: '净订单量', fmt: 'num', shortWidth: 85 }
    ]
  },
  {
    name: '退款指标（当天）',
    type: 'refund',
    fields: [
      { key: 'refund_amt', label: '成交退款金额(退款时间)', short: '退款额(退时)', tip: true, fmt: 'money', shortWidth: 105 },
      { key: 'rfndsuc_amt', label: '退款金额(退款时间)', short: '退款额(退)', tip: true, fmt: 'money', shortWidth: 95 },
      { key: 'refund_amt_pay_time', label: '成交退款金额(支付时间)', short: '退款额(付时)', tip: true, fmt: 'money', shortWidth: 105 },
      { key: 'rfndsuc_amt_pay_time', label: '退款金额(支付时间)', short: '退款额(付)', tip: true, fmt: 'money', shortWidth: 95 },
      { key: 'refund_amt_rate', label: '退款率(支付时间)', short: '退款率', tip: true, fmt: 'rate', shortWidth: 80 },
      { key: 'saling_refund_amt_rate_pay_time', label: '发货前退款率(支付时间)', short: '发前退率', tip: true, fmt: 'rate', shortWidth: 85 },
      { key: 'ship_refund_amt_rate_pay_time', label: '未收货退款率(支付时间)', short: '未收退率', tip: true, fmt: 'rate', shortWidth: 85 },
      { key: 'received_refund_amt_rate_pay_time', label: '已收货退款率(支付时间)', short: '已收退率', tip: true, fmt: 'rate', shortWidth: 85 },
      { key: 'received_return_good_amt_rate_pay_time', label: '已收货退货退款率(支付时间)', short: '收货退货率', tip: true, fmt: 'rate', shortWidth: 90 },
      { key: 'refund_order_cnt', label: '退款订单数(退款时间)', short: '退单数(退)', tip: true, fmt: 'num', shortWidth: 90 },
      { key: 'refund_order_cnt_pay_time', label: '退款订单数(支付时间)', short: '退单数(付)', tip: true, fmt: 'num', shortWidth: 90 },
      { key: 'refund_amt_one_hour_pay_time', label: '1小时成交退款金额(支付时间)', short: '1h退款额', tip: true, fmt: 'money', shortWidth: 90 },
      { key: 'refund_order_cnt_one_hour_pay_time', label: '1小时退款订单数(支付时间)', short: '1h退单数', tip: true, fmt: 'num', shortWidth: 85 },
      { key: 'refund_amt_ratio_one_hour_pay_time', label: '1小时成交退款率(支付时间)', short: '1h退款率', tip: true, fmt: 'rate', shortWidth: 85 }
    ]
  },
  {
    name: '流量指标（当天）',
    type: 'traffic',
    fields: [
      { key: 'product_show_ucnt', label: '商品曝光人数', short: '曝光人数', fmt: 'bignum', shortWidth: 90 },
      { key: 'product_click_ucnt', label: '商品点击人数', short: '点击人数', fmt: 'bignum', shortWidth: 90 },
      { key: 'product_show_click_ucnt_ratio', label: '商品曝光-点击转化率(人数)', short: '曝光点击率', tip: true, fmt: 'rate', shortWidth: 90 },
      { key: 'product_click_pay_ucnt_ratio', label: '商品点击-成交转化率(人数)', short: '点击成交率', tip: true, fmt: 'rate', shortWidth: 90 },
      { key: 'product_show_pay_ucnt_ratio', label: '商品曝光-成交转化率(人数)', short: '曝光成交率', tip: true, fmt: 'rate', shortWidth: 90 },
      { key: 'gpm', label: '千次曝光用户支付金额', short: '千曝支付额', tip: true, fmt: 'money', shortWidth: 95 },
      { key: 'product_show_cnt', label: '商品曝光次数', short: '曝光次数', fmt: 'bignum', shortWidth: 90 },
      { key: 'product_click_cnt', label: '商品点击次数', short: '点击次数', fmt: 'bignum', shortWidth: 90 },
      { key: 'product_show_click_cnt_ratio', label: '商品曝光-点击转化率(次数)', short: '曝光点击(次)', tip: true, fmt: 'rate', shortWidth: 100 },
      { key: 'product_click_pay_cnt_ratio', label: '商品点击-成交转化率(次数)', short: '点击成交(次)', tip: true, fmt: 'rate', shortWidth: 100 },
      { key: 'product_show_pay_cnt_ratio', label: '商品曝光-成交转化率(次数)', short: '曝光成交(次)', tip: true, fmt: 'rate', shortWidth: 100 }
    ]
  },
  {
    name: '店铺违规信息（实时）',
    type: 'violation',
    fields: [
      { key: 'pending_violation_count', label: '待处理违规', short: '待处理违规', fmt: 'num', shortWidth: 95 },
      { key: 'pending_operation_risk_count', label: '待整改经营风险', short: '待整改风险', fmt: 'num', shortWidth: 95 }
    ]
  },
  {
    name: '店铺订单信息（实时）',
    type: 'order',
    fields: [
      { key: 'pending_shipment_count', label: '待发货', short: '待发货', fmt: 'num', shortWidth: 80 },
      { key: 'shipment_due_24h_count', label: '24h需发货', short: '24h需发货', fmt: 'num', shortWidth: 90 },
      { key: 'overdue_shipment_count', label: '超时未发货', short: '超时未发货', fmt: 'num', shortWidth: 90 },
      { key: 'pending_payment_count', label: '待支付', short: '待支付', fmt: 'num', shortWidth: 80 },
      { key: 'pending_aftersale_count', label: '待处理售后', short: '待处理售后', fmt: 'num', shortWidth: 95 },
      { key: 'abnormal_package_count', label: '异常包裹', short: '异常包裹', fmt: 'num', shortWidth: 85 },
      { key: 'service_ticket_count', label: '服务工单', short: '服务工单', fmt: 'num', shortWidth: 85 }
    ]
  },
  {
    name: '店铺商品信息（实时）',
    type: 'product',
    fields: [
      { key: 'on_sale_product_count', label: '售卖中', short: '售卖中', fmt: 'num', shortWidth: 80 },
      { key: 'off_shelf_product_count', label: '已下架', short: '已下架', fmt: 'num', shortWidth: 80 }
    ]
  },
  {
    name: '营销活动信息（实时）',
    type: 'marketing',
    fields: [
      { key: 'active_coupon_count', label: '优惠券-进行中', short: '优惠券进行中', fmt: 'num', shortWidth: 100 },
      { key: 'active_product_discount_count', label: '单品直降-进行中', short: '单品直降中', fmt: 'num', shortWidth: 100 },
      { key: 'active_new_customer_gift_count', label: '新人礼金-进行中', short: '新人礼金中', fmt: 'num', shortWidth: 100 }
    ]
  },
  {
    name: '其他信息（实时）',
    type: 'other',
    fields: [
      { key: 'pending_invoice_count', label: '待开票', short: '待开票', fmt: 'num', shortWidth: 80 },
      { key: 'return_freight_insurance_status', label: '退换货运费险', short: '退换货运费险', fmt: 'status', shortWidth: 105 },
      { key: 'large_item_return_freight_insurance_status', label: '大件退换货运费险', short: '大件运费险', fmt: 'status', shortWidth: 105 }
    ]
  }
]

const wechatFieldGroups = [
  {
    name: '交易指标',
    type: 'trade',
    fields: [
      { key: 'income_amt', label: '成交金额', short: '成交金额', fmt: 'money', shortWidth: 100 },
      { key: 'net_pay_cnt', label: '成交订单数', short: '订单数', fmt: 'num', shortWidth: 80 },
      { key: 'net_pay_ucnt', label: '成交人数', short: '成交人数', fmt: 'num', shortWidth: 85 },
      { key: 'pay_amt', label: '下单金额', short: '下单金额', fmt: 'money', shortWidth: 100 },
      { key: 'pay_cnt', label: '下单订单数', short: '下单数', fmt: 'num', shortWidth: 80 },
      { key: 'pay_ucnt', label: '下单人数', short: '下单人数', fmt: 'num', shortWidth: 85 },
      { key: 'per_user_price', label: '客单价', short: '客单价', fmt: 'money', shortWidth: 80 }
    ]
  },
  {
    name: '退款指标',
    type: 'refund',
    fields: [
      { key: 'refund_amt', label: '退款金额', short: '退款金额', fmt: 'money', shortWidth: 95 },
      { key: 'pay_refund_success_amt', label: '成交退款金额', short: '成交退款额', fmt: 'money', shortWidth: 100 }
    ]
  },
  {
    name: '流量指标',
    type: 'traffic',
    fields: [
      { key: 'product_click_ucnt', label: '商品点击人数', short: '点击人数', fmt: 'bignum', shortWidth: 90 }
    ]
  }
]

const douyinDefaultFields = [
  'experience_score', 'pay_amt', 'pay_cnt', 'pay_ucnt', 'per_usr_pay_amt', 'income_amt',
  'refund_amt', 'refund_amt_rate',
  'product_show_ucnt', 'product_click_ucnt', 'product_show_click_ucnt_ratio'
]

const wechatDefaultFields = [
  'income_amt', 'net_pay_cnt', 'net_pay_ucnt', 'pay_amt', 'pay_cnt', 'pay_ucnt', 'per_user_price',
  'refund_amt', 'pay_refund_success_amt',
  'product_click_ucnt'
]

const STORAGE_KEY_DOUYIN = 'shop_board_field_config_douyin'
const STORAGE_KEY_WECHAT = 'shop_board_field_config_wechat'

export default {
  name: 'NewShopBoardPage',
  data() {
    return {
      loading: false,
      dataTime: '',
      activeStatTab: 'trade',
      statTabs: [
        { key: 'trade', label: '交易指标' },
        { key: 'refund', label: '退款指标' },
        { key: 'traffic', label: '流量指标' }
      ],
      statCardsMap: {
        trade: [
          { label: '支付金额', value: '¥0', sub: '¥745.66' },
          { label: '订单数', value: '0', sub: '9' },
          { label: '成交人数', value: '0', sub: '0' },
          { label: '客单价', value: '¥0', sub: '¥82.85' },
          { label: '成交金额', value: '¥0', sub: '¥745.66' }
        ],
        refund: [
          { label: '退款额(退时)', value: '¥0', sub: '¥0' },
          { label: '退款率', value: '0%', sub: '0%' }
        ],
        traffic: [
          { label: '曝光人数', value: '0', sub: '1,234' },
          { label: '点击人数', value: '0', sub: '320' },
          { label: '曝光点击率', value: '0.00%', sub: '37%' },
        ]
      },
      activeSummaryTab: 'hot',
      summaryTabs: [
        { key: 'hot', label: '爆款' },
        { key: 'moving', label: '动销款' },
        { key: 'nodata', label: '无数据款' },
        { key: 'task', label: '任务执行情况' }
      ],
      productStatusCards: [
        { key: 'hot', icon: '🔥', label: '爆款', count: 12, desc: '近7天销量TOP', color: '#c8443c', bg: '#FFF5F5', border: '#FFD6D6' },
        { key: 'moving', icon: '📈', label: '动销款', count: 38, desc: '近7天有成交', color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
        { key: 'stagnant', icon: '📈', label: '滞销款', count: 24, desc: '30天零成交', color: '#999999', bg: '#f5f5f5', border: '#e0e0ec' },
        { key: 'nodata', icon: '❓', label: '无数据款', count: 9, desc: '未采集数据', color: '#fa8c16', bg: '#fff7e6', border: '#ffd591' },
        { key: 'task_running', icon: '✅', label: '有任务执行', count: 31, desc: '当前有进行任务', color: '#1677ff', bg: '#e6f4ff', border: '#91caff' },
        { key: 'task_pending', icon: '⚠️', label: '待补任务', count: 14, desc: '缺失/未分配', color: '#fa8c16', bg: '#fff7e6', border: '#ffd591' }
      ],
      healthDistribution: [
        { key: 'hot', label: '爆款', count: 12, percent: 14, color: '#c8443c' },
        { key: 'moving', label: '动销款', count: 38, percent: 46, color: '#52c41a' },
        { key: 'stagnant', label: '滞销款', count: 24, percent: 29, color: '#999999' },
        { key: 'nodata', label: '无数据', count: 9, percent: 11, color: '#fa8c16' }
      ],
      taskDistribution: [
        { key: 'running', label: '有进行任务', count: 31, percent: 37, color: '#1677ff' },
        { key: 'missing', label: '缺失/待补', count: 14, percent: 17, color: '#fa8c16' },
        { key: 'done', label: '已完成', count: 18, percent: 22, color: '#52c41a' },
        { key: 'unassigned', label: '未分配', count: 20, percent: 24, color: '#999999' }
      ],
      searchData: { platform: 1, shop_id: '', group_id: '',score_range:'',has_violation:'',has_auth:'' },
      shopOptions: [],
      groupList: [],
      platformOptions: [
        { value: 1, label: '抖店' },
        { value: 7, label: '微店' }
      ],
      timeOptions: [
        { id: 1, name: '实时', day: 'realtime' },
        { id: 2, name: '近1天', day: '1' },
        { id: 3, name: '近7天', day: '7' },
        { id: 4, name: '近30天', day: '30' }
      ],
      scoreRangeOptions: [
        { value: '90+', label: '90分以上' },
        { value: '80-90', label: '80 - 90分' },
        { value: '70-80', label: '70 - 80分' },
        { value: '60-70', label: '60 - 70分' },
        { value: '0-60', label: '60分以下' },
      ],
      violationOptions: [
        { value: 2, label: '今日有违规' },
        { value: 3, label: '近3天有违规' },
        { value: 4, label: '近7天有违规' },
        { value: 1, label: '有违规' },
        { value: 0, label: '无违规' },
      ],
      authOptions: [
        { value: 1, label: '已授权' },
        { value: 2, label: '未授权' },
      ],
      timeSelectId: 1,
      customDateRange: '',
      datePickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && !maxDate) {
            // 当选择了开始日期但还没选择结束日期时，禁用超过31天的日期
            this.selectingStartDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          // 禁用未来日期
          if (time.getTime() > Date.now()) {
            return true;
          }
          // 如果正在选择日期范围，限制最多31天
          if (this.selectingStartDate) {
            const oneDay = 24 * 60 * 60 * 1000;
            const maxDays = 31;
            const minTime = this.selectingStartDate - maxDays * oneDay;
            const maxTime = this.selectingStartDate + maxDays * oneDay;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return false;
        }
      },
      selectingStartDate: null,
      customStart: '',
      customEnd: '',
      tableData: [],
      pageData: { page: 1, limit: 20, total: 0 },
      douyinSelectedFields: [],
      wechatSelectedFields: [],
      tempSelectedFields: [],
      showFieldConfig: false,
      showViolationDialog: false,
      violationDialogTitle: '',
      currentShop: null,
      violationList: [],
      selectedRows: [],
      groupManageVisible: false,
      groupFormVisible: false,
      groupFormEdit: false,
      groupFormLoading: false,
      groupForm: { id: null, name: '', sort: 0 },
      groupLoading: false,
      groupListHasCount: false,
      batchGroupVisible: false,
      batchGroupId: '',
      batchGroupRows: [],
      batchGroupLoading: false
    }
  },
  computed: {
    currentStatCards() {
      return this.statCardsMap[this.activeStatTab] || []
    },
    fieldGroups() {
      return this.searchData.platform === 7 ? wechatFieldGroups : douyinFieldGroups
    },
    selectedFields() {
      return this.searchData.platform === 7 ? this.wechatSelectedFields : this.douyinSelectedFields
    },
    allFieldMap() {
      const map = {}
      this.fieldGroups.forEach((group) => {
        group.fields.forEach((f) => {
          map[f.key] = Object.assign({}, f, { groupType: group.type, groupName: group.name })
        })
      })
      return map
    },
    activeGroups() {
      const groups = []
      const groupMap = {}
      this.selectedFields.forEach((key) => {
        const col = this.allFieldMap[key]
        if (!col) return
        if (!groupMap[col.groupType]) {
          const g = { name: col.groupName, type: col.groupType, fields: [] }
          groupMap[col.groupType] = g
          groups.push(g)
        }
        groupMap[col.groupType].fields.push(col)
      })
      return groups
    },
    totalFieldCount() {
      return this.activeGroups.reduce((sum, g) => sum + g.fields.length, 0)
    },
    displayDateRangeText() {
      if (this.customStart && this.customEnd) return `${this.customStart} 至 ${this.customEnd}`
      if (this.timeSelectId) {
        const t = this.timeOptions.find((x) => x.id === this.timeSelectId)
        if (t && t.day === 'realtime') return '实时'
        if (t) return `近${t.name.replace('近', '')}`
      }
      return '--'
    },
    isAllSelected() {
      return this.tableData.length > 0 && this.tableData.every((row) => this.isRowSelected(row))
    },
    // 显示当前筛选的时间范围
    displayDateRange: {
      get() {
        // 如果有自定义日期范围，直接返回
        if (this.customDateRange && this.customDateRange.length === 2) {
          return this.customDateRange;
        }
        // 如果有明确的开始和结束时间，返回
        if (this.searchData.start_time && this.searchData.end_time) {
          return [this.searchData.start_time, this.searchData.end_time];
        }
        // 根据快捷标签计算日期范围
        if (this.timeSelectId) {
          const timeOption = this.timeOptions.find(t => t.id === this.timeSelectId);
          if (timeOption) {
            if (timeOption.day === 'realtime') {
              const today = this.formatDate(new Date());
              return [today, today];
            } else {
              const today = new Date();
              const days = parseInt(timeOption.day);
              const yesterday = new Date(today);
              yesterday.setDate(yesterday.getDate() - 1);
              const end = this.formatDate(yesterday);
              const start = new Date(yesterday);
              start.setDate(start.getDate() - (days - 1));
              const startDate = this.formatDate(start);
              return [startDate, end];
            }
          }
        }
        return '';
      },
      set(value) {
        // 当用户手动选择日期时，更新 customDateRange
        this.customDateRange = value;
      }
    }
  },
  created() {
    const storedDouyin = localStorage.getItem(STORAGE_KEY_DOUYIN)
    const storedWechat = localStorage.getItem(STORAGE_KEY_WECHAT)
    this.douyinSelectedFields = this.normalizeDouyinSelectedFields(this.parseStoredFields(storedDouyin, douyinDefaultFields))
    this.wechatSelectedFields = this.parseStoredFields(storedWechat, wechatDefaultFields)
    localStorage.setItem(STORAGE_KEY_DOUYIN, JSON.stringify(this.douyinSelectedFields))
    this.tempSelectedFields = [...this.selectedFields]
    this.loadShopList()
    this.loadGroupList()
    this.loadData()
  },
  methods: {
    ...mapActions({
      getShopDataSummary: 'shop_board/getShopDataSummary',
      getShopList: 'shop_board/getShopList',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
      opShopBoardGroupCreate: 'shop_board/opShopBoardGroupCreate',
      opShopBoardGroupUpdate: 'shop_board/opShopBoardGroupUpdate',
      opShopBoardGroupDelete: 'shop_board/opShopBoardGroupDelete',
      opShopBoardBatchSetGroup: 'shop_board/opShopBoardBatchSetGroup'
    }),
    parseStoredFields(rawValue, defaults) {
      if (!rawValue) return [...defaults]
      try {
        const fields = JSON.parse(rawValue)
        return Array.isArray(fields) ? fields : [...defaults]
      } catch (e) {
        return [...defaults]
      }
    },
    normalizeDouyinSelectedFields(fields) {
      const validKeys = new Set()
      douyinFieldGroups.forEach((group) => group.fields.forEach((field) => validKeys.add(field.key)))
      const normalized = Array.from(new Set(fields.filter((field) => validKeys.has(field))))
      if (!normalized.length) return [...douyinDefaultFields]
      if (!normalized.includes('experience_score')) normalized.unshift('experience_score')
      return normalized
    },
    loadShopList() {
      this.getShopList({
        data: { page_size: 100, page: 1, shop_type: this.searchData.platform },
        success: (res) => {
          if (res.code === 200 && res.data) {
            if (res.data.list && res.data.list.list) this.shopOptions = res.data.list.list
            else if (Array.isArray(res.data.list)) this.shopOptions = res.data.list
            else if (Array.isArray(res.data)) this.shopOptions = res.data
            else this.shopOptions = []
          }
        }
      })
    },
    loadGroupList(options = {}) {
      const { withCount = false, force = false } = options
      if (this.groupLoading) return
      if (!force && this.groupList.length > 0 && (!withCount || this.groupListHasCount)) return
      this.groupLoading = true
      this.getShopBoardGroupList({
        data: { with_count: withCount ? 1 : 0 },
        success: (res) => {
          this.groupLoading = false
          if (res.code === 200) {
            this.groupList = res.data || []
            this.groupListHasCount = withCount
            if (this.searchData.group_id && !this.groupList.find(item => item.id === this.searchData.group_id)) {
              this.searchData.group_id = ''
            }
          } else {
            this.$message.error(res.message || '获取分组失败')
          }
        }
      })
    },
    switchPlatform(platform) {
      this.searchData.platform = platform
      this.searchData.shop_id = ''
      this.tempSelectedFields = [...this.selectedFields]
      this.loadShopList()
      this.reloadFirstPage()
    },
    // 自定义日期变更
    customDateChange() {
      // 重置选择状态
      this.selectingStartDate = null;

      if (this.customDateRange && this.customDateRange.length === 2) {
        // 验证日期范围不超过31天
        const start = new Date(this.customDateRange[0]);
        const end = new Date(this.customDateRange[1]);
        const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

        if (diffDays > 31) {
          this.$message.warning('时间范围不能超过31天');
          this.customDateRange = '';
          return;
        }

        this.timeSelectId = '';
        this.searchData.start_time = this.customDateRange[0];
        this.searchData.end_time = this.customDateRange[1];
      } else {
        this.timeSelectId = 1;
        this.searchData.start_time = '';
        this.searchData.end_time = '';
      }
      this.reloadFirstPage();
    },
    selectTime(t) {
      this.timeSelectId = t.id
      this.customStart = ''
      this.customEnd = ''
      this.customDateRange=[]
      this.searchData.start_time = ''
      this.searchData.end_time = ''
      this.reloadFirstPage()
    },
    resetSearch() {
      this.searchData = { platform: this.searchData.platform, shop_id: '', group_id: '',score_range:'',has_violation:'',has_auth:'' }
      this.timeSelectId = 1
      this.customStart = ''
      this.customEnd = ''
      this.customDateRange = []
      this.reloadFirstPage()
    },
    buildTimeParams() {
      const params = {}
      if (this.customDateRange && this.customDateRange.length === 2) {
        params.start_date = this.customDateRange[0]
        params.end_date = this.customDateRange[1]
        params.is_realtime = 0
        return params
      }
      const today = new Date()
      const t = this.timeOptions.find((x) => x.id === this.timeSelectId)
      if (t && t.day === 'realtime') {
        params.start_date = this.formatDate(today)
        params.end_date = this.formatDate(today)
        params.is_realtime = 1
      } else if (t) {
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)
        const end = this.formatDate(yesterday)
        const start = new Date(yesterday)
        start.setDate(start.getDate() - (parseInt(t.day) - 1))
        params.start_date = this.formatDate(start)
        params.end_date = end
        params.is_realtime = 0
      } else {
        params.start_date = this.formatDate(today)
        params.end_date = this.formatDate(today)
        params.is_realtime = 1
      }
      return params
    },
    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    reloadFirstPage() {
      this.pageData.page = 1
      this.loadData(1)
    },
    handlePagination({ page, limit }) {
      this.pageData.page = page
      this.pageData.limit = limit
      this.loadData(page)
    },
    loadData(page = this.pageData.page) {
      this.loading = true
      this.pageData.page = page
      const params = this.buildTimeParams()
      params.page = this.pageData.page
      params.page_size = this.pageData.limit
      if (this.searchData.platform) params.platform = this.searchData.platform
      if (this.searchData.shop_id) params.mer_shop_id = this.searchData.shop_id
      if (this.searchData.group_id !== '' && this.searchData.group_id !== null) params.group_id = this.searchData.group_id
      if (this.searchData.score_range) params.score_range = this.searchData.score_range;
      if (this.searchData.has_violation !== '' && this.searchData.has_violation !== null) params.has_violation = this.searchData.has_violation;
      if (this.searchData.has_auth !== '' && this.searchData.has_auth !== null) params.has_auth = this.searchData.has_auth;

      this.getShopDataSummary({
        data: params,
        success: (res) => {
          this.loading = false
          if (res.code === 200 && res.data) {
            if (res.data.data_time) this.dataTime = res.data.data_time
            if (Array.isArray(res.data)) this.tableData = res.data
            else if (res.data.list) {
              this.tableData = Array.isArray(res.data.list) ? res.data.list : []
              this.pageData.total = Number(res.data.total || 0)
              this.pageData.page = Number(res.data.page || this.pageData.page)
              this.pageData.limit = Number(res.data.page_size || this.pageData.limit)
            } else {
              this.tableData = []
              this.pageData.total = 0
            }
          } else {
            this.$message.error(res.msg || res.message || '获取数据失败')
            this.tableData = []
            this.pageData.total = 0
          }
        }
      })
    },
    platformName(platform) {
      if (platform === 1 || platform === '1') return '抖店'
      if (platform === 7 || platform === '7') return '微信小店'
      return platform
    },
    scoreClass(score) {
      if (score >= 90) return 'gx-sb__score--excellent'
      if (score >= 80) return 'gx-sb__score--good'
      if (score >= 70) return 'gx-sb__score--normal'
      return 'gx-sb__score--low'
    },
    scorePercent(score) {
      const n = Number(score)
      if (isNaN(n)) return 0
      return Math.max(0, Math.min(100, n))
    },
    shopInitial(name) {
      const text = String(name || '').trim()
      return text ? text.charAt(0) : '店'
    },
    formatCell(col, val) {
      if (val === undefined || val === null || val === '') return '--'
      if (col.fmt === 'money') {
        const amount = Number(val)
        if (isNaN(amount)) return '--'
        const text = amount.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1')
        return `¥${text}`
      }
      if (col.fmt === 'rate') return val + '%'
      if (col.fmt === 'bignum') return Number(val).toLocaleString()
      if (col.fmt === 'status') {
        if (val === 'enabled') return '已开通'
        if (val === 'disabled') return '未开通'
        return '--'
      }
      return val
    },
    cellClass(col, val) {
      if (col.fmt === 'rate' || col.fmt === 'money') {
        const n = Number(val)
        if (!isNaN(n) && n < 0) return 'gx-sb__cell--negative'
      }
      return ''
    },
    groupBar(type) {
      const map = {
        experience: '#8B5CF6', trade: '#D4A946', refund: '#FB923C', traffic: '#3FB6E0',
        violation: '#EF4444', order: '#F59E0B', product: '#10B981', marketing: '#EC4899', other: '#64748B'
      }
      return map[type] || '#D4A946'
    },
    groupHeadStyle(group) {
      const map = {
        experience: '#f3e8ff', trade: '#e8f4fd', refund: '#fef0e6', traffic: '#e9f7ef',
        violation: '#fef2f2', order: '#fffbeb', product: '#ecfdf5', marketing: '#fdf2f8', other: '#f8fafc'
      }
      return { background: map[group.type] || '#eef1f6' }
    },
    groupColStyle(group) {
      const map = {
        experience: '#f3e8ff', trade: '#e8f4fd', refund: '#fef0e6', traffic: '#e9f7ef',
        violation: '#fef2f2', order: '#fffbeb', product: '#ecfdf5', marketing: '#fdf2f8', other: '#f8fafc'
      }
      return { background: map[group.type] || '#eef1f6' }
    },
    openFieldConfig() {
      this.tempSelectedFields = [...this.selectedFields]
      this.showFieldConfig = true
    },
    closeFieldConfig() {
      this.showFieldConfig = false
    },
    toggleGroup(group) {
      if (this.isGroupAll(group)) {
        this.tempSelectedFields = this.tempSelectedFields.filter((k) => !group.fields.some((f) => f.key === k))
      } else {
        group.fields.forEach((f) => {
          if (!this.tempSelectedFields.includes(f.key)) this.tempSelectedFields.push(f.key)
        })
      }
    },
    isGroupAll(group) {
      return group.fields.every((f) => this.tempSelectedFields.includes(f.key))
    },
    selectedFieldCount(group) {
      return group.fields.filter((f) => this.tempSelectedFields.includes(f.key)).length
    },
    jumpPage(id) {
        // this.$router.replace({ path: '/new_ops_workbench', query: { menu: id } }).catch(() => {})
      this.$emit('jump',{id})
    },

    confirmFieldConfig() {
      if (!this.tempSelectedFields.length) {
        this.$message.warning('请至少勾选一项指标')
        return
      }
      if (this.searchData.platform === 7) {
        this.wechatSelectedFields = [...this.tempSelectedFields]
        localStorage.setItem(STORAGE_KEY_WECHAT, JSON.stringify(this.wechatSelectedFields))
      } else {
        this.douyinSelectedFields = [...this.tempSelectedFields]
        localStorage.setItem(STORAGE_KEY_DOUYIN, JSON.stringify(this.douyinSelectedFields))
      }
      this.$message.success('指标配置已保存')
      this.showFieldConfig = false
    },
    goDetail(row) {
      const platform = row.platform || row.shop_type
      const id = row.mer_shop_id || row.shop_id
      this.$router.push({
        path: '/new_ops_workbench',
        // path: '/new_ops_workbench_shop_details',
        query: {
          menu: 'ops-shop',
          detail: id,
          // 详情组件兼容旧版路由参数 `id`，同时保留新工作台使用的 `detail`。
          id,
          shop_name: row.shop_name,
          platform
        }
      })
    },
    showViolations(row) {
      this.currentShop = row
      this.violationDialogTitle = row.shop_name || ''
      this.showViolationDialog = true
      this.loadViolations()
    },
    loadViolations() {
      const params = {
        mer_shop_id: this.currentShop.mer_shop_id || this.currentShop.shop_id,
        page: 1,
        limit: 20
      }
      getShopViolations(params).then((res) => {
        if (res.code === 200 && res.data) {
          this.violationList = res.data.list || []
        } else {
          this.$message.error(res.msg || res.message || '获取违规记录失败')
          this.violationList = []
        }
      }).catch(() => {
        this.$message.error('获取违规记录失败')
      })
    },
    isRowSelected(row) {
      return this.selectedRows.some(r => (r.mer_shop_id || r.shop_id) === (row.mer_shop_id || row.shop_id))
    },
    toggleSelectAll(e) {
      const currentPageIds = new Set(this.tableData.map((row) => row.mer_shop_id || row.shop_id))
      if (e.target.checked) {
        this.tableData.forEach((row) => {
          if (!this.isRowSelected(row)) this.selectedRows.push(row)
        })
        return
      }
      this.selectedRows = this.selectedRows.filter((row) => !currentPageIds.has(row.mer_shop_id || row.shop_id))
    },
    toggleRowSelect(row) {
      const idx = this.selectedRows.findIndex(r => (r.mer_shop_id || r.shop_id) === (row.mer_shop_id || row.shop_id))
      if (idx > -1) this.selectedRows.splice(idx, 1)
      else this.selectedRows.push(row)
    },
    /**
     * —— 分组管理 —— */
    openShopGroupManageDialog() {
      this.groupManageVisible = true
      this.loadGroupList({ withCount: true, force: true })
    },
    handleAddShopGroup() {
      this.groupForm = { id: null, name: '', sort: 0 }
      this.groupFormEdit = false
      this.groupFormVisible = true
    },
    handleEditShopGroup(row) {
      this.groupForm = { id: row.id, name: row.name, sort: row.sort || 0 }
      this.groupFormEdit = true
      this.groupFormVisible = true
    },
    submitShopGroupForm() {
      if (!this.groupForm.name || !this.groupForm.name.trim()) {
        this.$message.warning('请输入分组名称')
        return
      }
      this.groupFormLoading = true
      const data = { name: this.groupForm.name.trim(), sort: this.groupForm.sort || 0 }
      const callback = (res, successMessage) => {
        this.groupFormLoading = false
        if (res.code === 200) {
          this.$message.success(successMessage)
          this.groupFormVisible = false
          this.loadGroupList({ withCount: true, force: true })
        } else {
          this.$message.error(res.message || '操作失败')
        }
      }
      if (this.groupFormEdit) {
        this.opShopBoardGroupUpdate({
          id: this.groupForm.id,
          data,
          success: (res) => callback(res, '修改成功')
        })
        return
      }
      this.opShopBoardGroupCreate({
        data,
        success: (res) => callback(res, '新增成功')
      })
    },
    handleDeleteShopGroup(row) {
      this.$confirm(`确定删除分组「${row.name}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opShopBoardGroupDelete({
          id: row.id,
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.loadGroupList({ withCount: true, force: true })
              this.reloadFirstPage()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          }
        })
      }).catch(() => {})
    },
    moveShopGroup(row,index,type){
      if(index===0&&type==='asc') return
      if(index===this.groupList.length-1&&type==='desc') return
      let sort =0
      if(type==='asc') sort = this.groupList[index-1].sort-1
      if(type==='desc') sort = this.groupList[index+1].sort+1
      this.opShopBoardGroupUpdate({
        id: row.id,
        data:{ name: row.name.trim(), sort:sort<0?0:sort },
        success: (res) => {
          if(res.code===200){
            this.loadGroupList({ withCount: true, force: true })
          }
        }
      })
    },

    /**
     * —— 设置分组 ——*/
    openShopBatchGroupDialog(rows) {
      const targetRows = Array.isArray(rows) && rows.length > 0 ? rows : this.selectedRows
      if (!targetRows || targetRows.length === 0) {
        this.$message.warning('请先选择店铺')
        return
      }
      this.batchGroupRows = targetRows
      this.batchGroupId = targetRows.length === 1 && targetRows[0].group_id ? targetRows[0].group_id : ''
      this.batchGroupVisible = true
      this.loadGroupList({ withCount: false, force: this.groupList.length === 0 })
    },
    submitShopBatchSetGroup() {
      if (this.batchGroupId === '' || this.batchGroupId === null) {
        this.$message.warning('请选择分组')
        return
      }
      const merShopIds = Array.from(new Set(this.batchGroupRows.map(item => Number(item.mer_shop_id || item.shop_id)).filter(Boolean)))
      if (merShopIds.length === 0) {
        this.$message.warning('未找到可设置的店铺')
        return
      }
      this.batchGroupLoading = true
      const isRemoveGroup = this.batchGroupId === 0
      this.opShopBoardBatchSetGroup({
        data: {
          mer_shop_ids: merShopIds,
          group_id: isRemoveGroup ? null : this.batchGroupId
        },
        success: (res) => {
          this.batchGroupLoading = false
          if (res.code === 200) {
            this.$message.success(isRemoveGroup ? '已移出分组' : '设置成功')
            this.batchGroupVisible = false
            this.batchGroupRows = []
            this.selectedRows = []
            this.loadGroupList({ withCount: this.groupManageVisible, force: true })
            this.reloadFirstPage()
          } else {
            this.$message.error(res.message || '设置失败')
          }
        }
      })
    },
    formatTimestamp(ts) {
      if (!ts) return '--'
      const d = new Date(ts * 1000)
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    }
  }
}
</script>

<style scoped>
.w140{
  width: 140px;
}
.gx-sb__head {
  display: flex;
  align-items: center;
  gap:8px;
  margin-bottom: 14px;
}
.gx-sb__head .btn{
  height: 32px;
  padding: 0px 16px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 600;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  color: rgb(102, 102, 102);
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none;
  transform: none;
}
.gx-sb__head .btn:disabled{
  cursor: not-allowed;
}
.gx-sb__head .btn--primary{
  background: transparent;
  border: 1px solid rgb(212, 169, 70);
  color: rgb(212, 169, 70);
}
.gx-sb__head .btn--primary:hover{
  background:rgba(225,229,238);
  box-shadow: rgba(212, 169, 70,0.3) 0 0 10px;
  transform: scale(1.3);
}
/*平台tabs*/
.gx-sb__plat-tabs {
  display: flex;
  border-bottom: 1px solid rgb(224, 224, 236);
  margin-bottom: 14px;
}
.gx-sb__plat-tab {
  padding: 9px 24px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 14px;
  background: transparent;
  color: rgb(102, 102, 102);
  font-weight: 400;
}
.gx-sb__plat-tab--on {
 border-bottom:2px solid rgb(212, 169, 70);
  color: rgb(212, 169, 70);
  font-weight: 600;
}
/*筛选*/
.gx-sb__filter {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  padding: 10px 14px;
  margin-bottom: 12px;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 4px;
  gap: 9px;
}
.gx-sb__select {
  height: 28px;
  padding: 0 8px;
  border: 2px solid #E0E0EC;
  border-radius: 4px;
  outline: none;
  font-size: 11px;
  color: #1A1A2E;
  background: #FFFFFF;
  min-width: 110px;
}
.gx-sb__time {
  display: flex;
  align-items: center;
  gap: 3px;
}
.gx-sb__time-btn {
  height: 26px;
  padding: 0 9px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 11px;
  background: #FFFFFF;
  border: 1px solid #E0E0EC;
  color: #666;
  transition: all .13s;
  white-space: nowrap;
}
.gx-sb__time-btn--on {
  background: #E1E5EE;
  border-color: rgba(212, 169, 70, .5);
  color: #D4A946;
}
.gx-sb__input {
  width: 108px;
  height: 28px;
  padding: 0 8px;
  border: 2px solid #E0E0EC;
  border-radius: 4px;
  outline: none;
  font-size: 11px;
  color: #1A1A2E;
  background: #FFFFFF;
  box-sizing: border-box;
}
.gx-sb__input:focus {
  border-color: rgba(212, 169, 70, .65);
}
.gx-sb__btn {
  height: 32px;
  padding: 0 16px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 400;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  color: rgb(102, 102, 102);
  opacity: 1;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none;
  transform: none;
}
.gx-sb__btn--sm{
  height: 28px;
  padding: 0 12px;
  border-radius: 4px;
  font-size: 12px;
}
.gx-sb__btn--mi{
  height: 22px;
  padding: 0 9px;
  border-radius: 4px;
  font-size: 11px;
}
.gx-sb__btn:hover {
  background: rgb(245,245,245);
}
.gx-sb__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}



.gx-sb__btn--blue{
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
  color: rgb(22, 119, 255);
}
.gx-sb__btn--blue:hover {
  background: rgb(22, 119, 255);
  color: #FFFFFF;
}
.gx-sb__btn--yellow{
  background: rgba(212, 169, 70, 0.1);
  border: 1px solid rgba(212, 169, 70, 0.4);
  color: rgb(212, 169, 70);
}
.gx-sb__btn--yellow:hover {
  background: rgb(212, 169, 70);
  color: #FFFFFF;
}

/*数据时间*/
.gx-sb__meta {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  font-size: 11px;
  color: #999999;
}
.gx-sb__sel-tag{
  width: max-content;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 4px;
  background: rgb(255, 248, 230);
  border: 1px solid rgba(212, 169, 70, 0.4);
  font-size: 11px;
  color: rgb(212, 169, 70);
  font-weight: 500;
}
.gx-sb__sel-tag-dot{
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgb(212, 169, 70);
}


/*商品状态汇总*/
.gx-sb__summary {
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  background: rgb(255, 255, 255);
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 4px;
}
.gx-sb__summary-head {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 14px;
  background: rgb(238, 241, 246);
  border-bottom: 1px solid rgb(224, 224, 236);
}
.gx-sb__summary-title {
  font-family: "Noto Serif SC", serif;
  font-size: 12px;
  font-weight: 700;
  color: rgb(26, 26, 46);
  position: relative;
  padding-left: 10px;
}
.gx-sb__summary-title::before{
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 3px;
  height: 13px;
  border-radius: 2px;
  background: rgb(200, 68, 60);
}
.gx-sb__summary-dec {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  flex: 1 1 0%;
}
.gx-sb__summary-btns {
  margin-left: auto;
  display: flex;
  gap: 8px;
}
.gx-sb__summary-body{
  padding: 12px 14px;
}
.gx-sb__summary-cards {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  margin-bottom: 12px;
}
.gx-sb__summary-card {
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid;
  transition: box-shadow .2s;
}
.gx-sb__summary-card:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, .08);
}
.gx-sb__summary-card-top {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.gx-sb__summary-ico {
  font-size: 14px;
  line-height: 1;
}
.gx-sb__summary-card-label {
  font-size: 12px;
  font-weight: 500;
}
.gx-sb__summary-card-num {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.1;
  margin-bottom: 4px;
}
.gx-sb__summary-card-sub {
  font-size: 11px;
  color: #999999;
}
.gx-sb__summary-bars {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.gx-sb__summary-bar-col {
  border-radius: 6px;
  padding: 10px 12px;
  background: rgb(248, 249, 252);
  border: 1px solid rgb(224, 224, 236);
}
.gx-sb__summary-bar-title {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(102, 102, 102);
  font-weight: 600;
  margin-bottom: 8px;
}
.gx-sb__summary-bar-item{
  margin-bottom: 5px;
}
.gx-sb__summary-bar-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
}
.gx-sb__summary-bar-label {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
}
.gx-sb__summary-bar-track {
  width: 100%;
  height: 5px;
  border-radius: 3px;
  background: rgb(224, 224, 232);
  overflow: hidden;
}
.gx-sb__summary-bar-fill {
  display: block;
  height: 100%;
  border-radius: 3px;
  transition: width .3s;
}
.gx-sb__summary-bar-val {
  font-family: "JetBrains Mono", monospace;
  font-size: 10px;
  font-weight: 700;
}

/*指标条*/
.gx-sb__stats {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  margin-bottom: 12px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 4px;
}
.gx-sb__stats-tabs {
  display: flex;
  border-bottom: 1px solid rgb(224, 224, 236);
  background: rgb(238, 241, 246);
}
.gx-sb__stats-tab {
  padding: 8px 18px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  background: rgba(0, 0, 0, 0);
  color: rgb(102, 102, 102);
  font-weight: 400;
  transition: 0.15s;
}

.gx-sb__stats-tab--on {
  color: #D4A946;
  border-bottom-color: #D4A946;
  font-weight: 600;
}
.gx-sb__stats-row {
  display: flex;
}
.gx-sb__stats-cell {
  flex: 1 1 0%;
  padding: 13px 16px;
  border-right: 1px solid #e1e5ee;
  font-family: "Noto Sans SC", sans-serif;
}
.gx-sb__stats-cell:last-child {
  border-right: none;
}
.gx-sb__stats-label {
  font-size: 11px;
  color: rgb(102, 102, 102);
  margin-bottom: 7px;
}
.gx-sb__stats-num {
  font-family: "JetBrains Mono", monospace;
  font-size: 20px;
  font-weight: 700;
  color: rgb(156, 163, 181);
  line-height: 1;
  margin-bottom: 4px;
}
.gx-sb__stats-sub {
  font-size: 10px;
  color: rgb(153, 153, 153);
}

/* 表格 */
.gx-sb__table-page-wrapper {
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #E0E0EC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  overflow: hidden;
}
.gx-sb__table {
  background: #FFFFFF;
  border-radius: 8px 8px 0 0;
  overflow-x: auto;
}
.gx-sb__page {
  padding: 10px 14px;
  border-top: 1px solid #E0E0EC;
  background: #EEF1F6;
}
.gx-sb__table::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.gx-sb__table::-webkit-scrollbar-thumb {
  background: rgba(212, 169, 70, .35);
  border-radius: 2px;
}
.gx-sb__table::-webkit-scrollbar-track {
  background: #F4F6F8;
}
.gx-sb__table table {
  min-width: 980px;
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;

}
.gx-sb__table thead tr {
  background: #EEF1F6;
}
.gx-sb__table th {
  padding: 9px 12px;
  text-align: left;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #666666;
  border-bottom: 1px solid #E0E0EC;
  white-space: nowrap;
}
.gx-sb__table td {
  padding: 11px 12px;
  font-size: 12px;
  color: #1A1A2E;
  border-top: 1px solid #F5F5F5;
  text-align: left;
  background: #FFFFFF;
}
.gx-sb__table tbody tr:hover td {
  background: #FFFBF4;
}
.gx-sb__th-col {
  font-weight: 500;
  font-size: 11px;
}
.gx-sb__td-col {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
}
.gx-sb__td-col {
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  color: #999999 !important;
  font-weight: 400;
}
.gx-sb__td-col .gx-sb__cell--negative {
  color: #C8443C;
  font-weight: 600;
}

.gx-sb__td-fixed {
  background: #FDFDFE;
  position: sticky;
}

.gx-sb__th-shop,
.gx-sb__td-shop {
  min-width: 190px;
}
.gx-sb__th-score {
  min-width: 90px;
}
.gx-sb__th-auth {
  min-width: 88px;
}
.gx-sb__th-ops,
.gx-sb__td-ops {
  min-width: 130px;
  text-align: left !important;
}
.gx-sb__td-score {
  min-width: 90px;
}
.gx-sb__td-auth {
  min-width: 88px;
}

.gx-sb__sort {
  color: #DDDDDD;
  font-size: 9px;
  margin-left: 2px;
}
.gx-sb__shop-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-start;
  min-width: 160px;
}
.gx-sb__shop-name {
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-sb__auth {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
}
.gx-sb__auth--ok {
  background: rgba(74, 222, 128, .1);
  border: 1px solid rgba(74, 222, 128, .3);
  color: #22C55E;
}
.gx-sb__auth--err {
  background: rgba(248, 113, 113, .1);
  border: 1px solid rgba(248, 113, 113, .3);
  color: #F87171;
}
.gx-sb__cell--negative {
  color: #F87171;
}
.gx-sb__ops {
  display: flex;
  gap: 5px;
  justify-content: flex-start;
  min-width: 120px;

}
.gx-sb__op {
  height: 24px;
  padding: 0 9px;
  border-radius: 4px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  cursor: pointer;
  border: 1px solid;
  transition: all .15s;
  white-space: nowrap;
}
.gx-sb__op--view {
  background: #FFF5F5;
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-sb__op--view:hover {
  background: #C8443C;
  color: #fff;
}
.gx-sb__op--warn {
  background: #FFF7E6;
  border-color: #FFD591;
  color: #FA8C16;
}
.gx-sb__op--warn:hover {
  background: #FA8C16;
  color: #fff;
}
.gx-sb__empty {
  text-align: center!important;
  padding: 52px 0 !important;
  color: #999999 !important;
}

/*弹窗*/
.gx-modal-foot--gray{
  margin: 0;
  padding: 12px 18px;
  border-top: 1px solid rgb(224, 224, 236);
  background: rgb(238, 241, 246);
}
.gx-sb__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-sb__modal-box {
  width: 100%;
  max-width: 480px;
  border-radius: 16px;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .28);
  box-shadow: 0 20px 56px rgba(15, 23, 42, .14);
  overflow: hidden;
}
.gx-sb__modal-box--sm{
  max-width: 400px;
}
.gx-sb__modal-box--lg {
  max-width: 760px;
  max-height: 90vh;
  overflow-y: auto;
}
.gx-sb__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #E1E5EE;
  position: sticky;
  top: 0;
  background: #FFFFFF;
}
.gx-sb__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-sb__modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6A6A8A;
  font-size: 14px;
}
.gx-sb__modal-body {
  padding: 18px 20px;
}
.gx-sb__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E1E5EE;
  position: sticky;
  bottom: 0;
  background: #FFFFFF;
}

.gx-sb__modal-label {
  font-size: 11px;
  color: #6A6A8A;
  letter-spacing: .08em;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.gx-sb__gm-sort-input {
  display: flex;
  align-items: center;
  border: 1px solid #E1E5EE;
  border-radius: 4px;
  overflow: hidden;
  width: 120px;
}
.gx-sb__gm-sort-input button {
  width: 32px;
  height: 32px;
  border: none;
  background: #eef1f6;
  cursor: pointer;
  font-size: 16px;
  color: #1A1A2E;
}
.gx-sb__gm-sort-input input {
  min-width: 0;
  flex: 1;
  height: 32px;
  border: none;
  outline: none;
  text-align: center;
  font-family: 'JetBrains Mono', monospace;
  font-size: 14px;
  color: #1A1A2E;
}


.gx-sb__cfg-group {
  margin-bottom: 18px;
}
.gx-sb__cfg-group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
  margin-bottom: 10px;
}
.gx-sb__cfg-bar {
  display: none;
}
.gx-sb__cfg-count {
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: #999999;
}
.gx-sb__cfg-checkall {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 11px;
  color: #999999;
  padding: 0;
  line-height: 18px;
}
.gx-sb__cfg-checkall:hover {
  color: #C8443C;
}
.gx-sb__cfg-items {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
}
.gx-sb__cfg-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 28px;
  padding: 4px 11px;
  border-radius: 4px;
  border: 1px solid #E0E0EC;
  background: #F5F5F5;
  cursor: pointer;
  font-size: 12px;
  line-height: 18px;
  color: #666666;
  user-select: none;
  transition: border-color .15s, background-color .15s, color .15s;
}
.gx-sb__cfg-item input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
.gx-sb__cfg-item:hover {
  border-color: rgba(200, 68, 60, .65);
}
.gx-sb__cfg-item--on {
  background: #FFF5F5;
  border-color: #C8443C;
  color: #C8443C;
}
.gx-sb__cfg-item--on::before {
  content: '\2713';
  margin-right: 4px;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
}
.gx-sb__field-config-modal {
  padding: 20px;
  background: rgba(26, 26, 46, .44);
  backdrop-filter: blur(4px);
}
.gx-sb__field-config-box {
  width: 100%;
  max-width: 60%;
  max-height: calc(100vh - 40px);
  border: none;
  border-radius: 10px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, .18);
}
.gx-sb__field-config-box .gx-modal-body {
  max-height: calc(100vh - 170px);
  overflow-y: auto;
  padding: 18px;
}
.gx-sb__field-config-box .gx-modal-foot--gray {
  padding: 14px 18px 16px;
  background: #EEF1F6;
}

@media (max-width: 560px) {
  .gx-sb__field-config-modal {
    padding: 12px;
  }
  .gx-sb__field-config-box .gx-modal-body {
    padding: 16px;
  }
  .gx-sb__cfg-items {
    gap: 6px;
  }
  .gx-sb__cfg-item {
    padding-left: 9px;
    padding-right: 9px;
  }
}
.gx-sb__violation-table {
  max-height: 60vh;
  overflow-y: auto;
}
.gx-sb__violation-table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-sb__violation-table thead{
  position: sticky;
  top: 0;
}
.gx-sb__violation-table th {
  padding: 9px 14px;
  text-align: left;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgb(102, 102, 102);
  background: rgb(238, 241, 246);
  border-bottom: 1px solid rgb(224, 224, 236);
  letter-spacing: 0.04em;
}
.gx-sb__violation-table td {
  padding: 9px 14px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #666666;
  border-top: 1px solid rgb(245, 245, 245);
}
.gx-sb__violation-title {
  font-size: 12px;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-sb__violation-tag {
  padding: 1px 8px;
  border-radius: 3px;
  background: rgba(232, 93, 93, 0.082);
  border: 1px solid rgba(232, 93, 93, 0.25);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgb(232, 93, 93);
}
.gx-sb__violation-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid rgb(224, 224, 236);
  background: rgb(238, 241, 246);
}
.gx-sb__violation-total{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(153, 153, 153);
}
.gx-sb__violation-btn{
  height: 28px;
  padding: 0px 14px;
  border-radius: 4px;
  background: rgb(200, 68, 60);
  border-width: medium;
  border-style: none;
  border-color: currentcolor;
  border-image: none;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgb(255, 255, 255);
}
.gx-sb__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px !important;
}
.gx-sb__red {
  color:rgb(200,68,60) !important;
  font-weight: 600 !important;
}
.gx-sb__gray{
  color: rgb(153, 153, 153);
  font-weight: 400;
}

/* 复选框 */
.gx-sb__checkall,
.gx-sb__check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #666;
}
.gx-sb__checkall input,
.gx-sb__check input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-sb__checkall-box,
.gx-sb__check-box {
  width: 15px;
  height: 15px;
  border-radius: 3px;
  border: 1.5px solid rgb(224, 224, 236);
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all .15s;
  box-sizing: border-box;
}
.gx-sb__checkall input:checked + .gx-sb__checkall-box,
.gx-sb__check input:checked + .gx-sb__check-box {
  background: rgb(200, 68, 60);
  border: 1.5px solid rgb(200, 68, 60);
}

.gx-sb__shop-cell {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 170px;
}
.gx-sb__shop-avatar {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: #E1E5EE;
  border: 1px solid rgba(212, 169, 70, .3);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "Noto Serif SC", serif;
  font-size: 12px;
  font-weight: 700;
  color: #D4A946;
  flex-shrink: 0;
}
.gx-sb__shop-name {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #1A1A2E;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gx-sb__score-wrap {
  display: flex;
  align-items: center;
  gap: 5px;
}
.gx-sb__score-track {
  width: 44px;
  height: 4px;
  border-radius: 2px;
  background: #F0F0F0;
  overflow: hidden;
  flex-shrink: 0;
}
.gx-sb__score-fill {
  display: block;
  height: 100%;
  border-radius: 2px;
}
.gx-sb__score-fill.gx-sb__score--excellent,
.gx-sb__score-value.gx-sb__score--excellent { color: #52C41A; background-color: #52C41A; }
.gx-sb__score-fill.gx-sb__score--good,
.gx-sb__score-value.gx-sb__score--good { color: #D4A946; background-color: #D4A946; }
.gx-sb__score-fill.gx-sb__score--normal,
.gx-sb__score-value.gx-sb__score--normal { color: #FA8C16; background-color: #FA8C16; }
.gx-sb__score-fill.gx-sb__score--low,
.gx-sb__score-value.gx-sb__score--low { color: #C8443C; background-color: #C8443C; }
.gx-sb__score-value {
  min-width: 22px;
  padding: 0;
  background: transparent !important;
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  font-weight: 600;
}

.gx-sb__auth {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
}
.gx-sb__auth-dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  margin-right: 4px;
  border-radius: 50%;
  background: currentColor;
}
.gx-sb__auth--ok {
  background: #F6FFED;
  border: 1px solid #B7EB8F;
  color: #52C41A;
}
.gx-sb__auth--err {
  background: #FFF2F0;
  border: 1px solid #FFCCC7;
  color: #C8443C;
}

.gx-sb__modal-box--md {
  max-width: 680px;
}
.gx-sb__modal-box--sm {
  max-width: 420px;
}
.gx-sb__gm-toolbar {
  margin-bottom: 12px;
}
.gx-sb__gm-table {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgb(224, 224, 236);
}
.gx-sb__gm-table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-sb__gm-table th {
  padding: 8px 12px;
  text-align: left;
  background: rgb(238, 241, 246);
  font-size: 11px;
  font-weight: 500;
  color:#666;
  border-bottom: 1px solid rgb(224, 224, 236);
}
.gx-sb__gm-table td {
  padding: 8px 12px;
  font-size: 13px;
  color: #1A1A2E;
  border-top: 1px solid rgb(245, 245, 245);
}
.gx-sb__td-red{
  font-weight: 600;
  color: rgb(200,68,60);
}
.gx-sb__gm-sort {
  display: flex;
  gap: 3px;
}
.gx-sb__gm-sort button {
  width: 22px;
  height: 22px;
  border-radius: 3px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #4A4A6A;
  transition: all .16s;
}
.gx-sb__gm-sort button:hover {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-sb__td-btn{
  height: 24px;
  padding: 0px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
}
.gx-sb__td-btn~.gx-sb__td-btn{
  margin-left: 6px;
}
.gx-sb__td-btn-edit{
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
  color: rgb(22, 119, 255);
}
.gx-sb__td-btn-edit:hover {
  background:rgb(22, 119, 255);
  color: #FFFFFF;
}
.gx-sb__td-btn-del{
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(200, 68, 60);
}
.gx-sb__td-btn-del:hover{
  background: rgb(200, 68, 60);
  color: #FFFFFF;
}

.gx-sb__form-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.gx-sb__form-row label {
  width: 80px;
  flex-shrink: 0;
  font-size: 12px;
  color: #4A4A6A;
  text-align: right;
}
.gx-sb__batch-tip {
  flex: 1;
  font-size: 12px;
  color: #1A1A2E;
}
</style>
